import { combineReducers } from "@reduxjs/toolkit";
import auth from "./slices/authSlice";
import { uMGroupPermissionsApi } from "./Api/UserManagment/uMGroupPermissionsApiSlice";
import { uMGroupsApi } from "./Api/UserManagment/uMGroupsApiSlice";
import { uMPermissionsApi } from "./Api/UserManagment/uMPermissionsApiSlice";
import { uMUserApi } from "./Api/UserManagment/uMUserApiSlice";
import { uMUserGroupsApi } from "./Api/UserManagment/uMUserGroupsApiSlice";
import { uMUserPermissionsApi } from "./Api/UserManagment/uMUserPermissionsApiSlice";
import { uMUsersApi } from "./Api/UserManagment/uMUsersApiSlice";
import { uMUsersContentTypesApi } from "./Api/UserManagment/uMUsersContentTypesApiSlice";
import { cMCampaignsApi } from "./Api/CampaignManagment/cMCampaignsApiSlice";
import { cMLanguagesApi } from "./Api/CampaignManagment/cMLanguagesApiSlice";
import { cMLoaApi } from "./Api/CampaignManagment/cMLoaApiSlice";
import { cMPlatformsApi } from "./Api/CampaignManagment/cMPlatformsApiSlice";
import { cMTypesApi } from "./Api/CampaignManagment/cMTypesApiSlice";
import { customerCampaignPlatformApi } from "./Api/CampaignManagment/cMCustomerCampaignPlatformApiSlice";
import { AnalyticsApi } from "./Api/AnalyticsApiSlice";
import { CustomerApi } from "./Api/CustomerApiSlice";
import { PlatformApi } from "./Api/PlatformApiSlice";
import { UtilsApi } from "./Api/UtilsApiSlice";
import { VideoApi } from "./Api/VideoApiSlice";
import { WhitelistApi } from "./Api/WhitelistApiSlice";
import { GuacamoleApi } from "./Api/GuacamoleManagment/GuacamoleApiSlice";

export default combineReducers({
    auth,
    [uMUserApi.reducerPath]: uMUserApi.reducer,
    [uMUsersApi.reducerPath]: uMUsersApi.reducer,
    [uMGroupPermissionsApi.reducerPath]: uMGroupPermissionsApi.reducer,
    [uMGroupsApi.reducerPath]: uMGroupsApi.reducer,
    [uMPermissionsApi.reducerPath]: uMPermissionsApi.reducer,
    [uMUserGroupsApi.reducerPath]: uMUserGroupsApi.reducer,
    [uMUserPermissionsApi.reducerPath]: uMUserPermissionsApi.reducer,
    [uMUsersContentTypesApi.reducerPath]: uMUsersContentTypesApi.reducer,
    [cMCampaignsApi.reducerPath]: cMCampaignsApi.reducer,
    [cMLanguagesApi.reducerPath]: cMLanguagesApi.reducer,
    [cMLoaApi.reducerPath]: cMLoaApi.reducer,
    [cMPlatformsApi.reducerPath]: cMPlatformsApi.reducer,
    [cMTypesApi.reducerPath]: cMTypesApi.reducer,
    [customerCampaignPlatformApi.reducerPath]: customerCampaignPlatformApi.reducer,
    [AnalyticsApi.reducerPath]: AnalyticsApi.reducer,
    [CustomerApi.reducerPath]: CustomerApi.reducer,
    [PlatformApi.reducerPath]: PlatformApi.reducer,
    [UtilsApi.reducerPath]: UtilsApi.reducer,
    [VideoApi.reducerPath]: VideoApi.reducer,
    [WhitelistApi.reducerPath]: WhitelistApi.reducer,
    [GuacamoleApi.reducerPath]: GuacamoleApi.reducer,
})